import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "category-tree-node__children"
};
import { ref, watch } from "vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import config from "../services/PortalConfig";
import categoryTreeSettings from "../services/CategoryTreeSettings";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryTreeNode',
    props: {
        category: {},
        activeCategory: {},
        level: {}
    },
    emits: ['select'],
    setup(__props) {
        const props = __props;
        const expanded = ref(isInitiallyExpanded());
        watch(() => props.activeCategory, () => {
            if (isInitiallyExpanded()) {
                expanded.value = true;
            }
        });
        function isInitiallyExpanded() {
            // the active path is always visible, even if the user collapsed an ancestor
            if (hasActiveSubCategory(props.category)) {
                return true;
            }
            const stored = categoryTreeSettings.isExpanded(props.category.code);
            if (stored !== undefined) {
                return stored;
            }
            return props.level < config.categories.expand;
        }
        function toggle() {
            expanded.value = !expanded.value;
            categoryTreeSettings.setExpanded(props.category.code, expanded.value);
        }
        function hasActiveSubCategory(cat) {
            return !!(cat.subCategories || []).find(subCategory => {
                return subCategory.code === props.activeCategory
                    || hasActiveSubCategory(subCategory);
            });
        }
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_CategoryTreeNode = _resolveComponent("CategoryTreeNode", true);
            return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["category-tree-node", { 'category-tree-node--active': __props.activeCategory == __props.category.code }])
            }, [
                _createVNode(_component_RouterLink, {
                    to: { name: 'catalog_category', params: { 'category': __props.category.code } },
                    class: "category-tree-node__link",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select', __props.category.code)))
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.category.name) + " ", 1),
                        (__props.category.subCategories && __props.category.subCategories.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button--link category-tree-node__toggle",
                                onClick: _withModifiers(toggle, ["stop", "prevent"])
                            }, [
                                _createVNode(Icon, {
                                    name: expanded.value ? 'chevron-up' : 'chevron-down'
                                }, null, 8, ["name"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["to"]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (expanded.value && __props.category.subCategories && __props.category.subCategories.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.category.subCategories, (subCategory) => {
                            return (_openBlock(), _createBlock(_component_CategoryTreeNode, {
                                key: subCategory.code,
                                category: subCategory,
                                "active-category": __props.activeCategory,
                                level: __props.level + 1,
                                onSelect: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('select', $event)))
                            }, null, 8, ["category", "active-category", "level"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
